import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

const IconMapFetchingS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path d="M12.592 2.667c0-.369-.315-.667-.703-.667-.39 0-.704.299-.704.667v2.666h-.704c-.389 0-.704.299-.704.667 0 .368.315.667.704.667h.704v2.666h-.704c-.389 0-.704.299-.704.667 0 .368.315.667.704.667h.704v2.665c0 .369.315.667.704.667.389 0 .704-.298.704-.667v-2.665h.703c.389 0 .704-.299.704-.667 0-.368-.315-.667-.704-.667h-.703V6.667h.703c.389 0 .704-.299.704-.667 0-.368-.315-.667-.704-.667h-.704V2.667ZM8.37 2l-3.686.765L2 6.705l1.331 5.146L8.37 14v-1.05l-3.523-1.54 2.666-1.443.857-.203v-1.03l-1.255.297-2.998 1.623-.723-2.743 3.585-1.94 1.39-.293V4.654l-1.775.374-3.465 1.876-.002-.009 2.22-3.26L8.37 3V2Z" />
  </svg>
)

export const IconMapFetching = createIcon({
  l: IconMapFetchingS,
  m: IconMapFetchingS,
  s: IconMapFetchingS,
  xs: IconMapFetchingS,
  name: 'IconMapFetching',
})
